export const onInputCoordinatesMask = (e) => e.target.value = e.target.value.replace(/[^0-9.,\s-]/g, '');